export default {
  title: 'Desarrolladores',
  subtitle: 'Claves de API, webhooks e historial de entregas para tu integración con la API de Partners.',
  no_account: 'Aún no tienes una cuenta de API de Partners; contacta a Foodamigos para que te proporcionen una.',
  no_account_manage: 'Aún no hay cuenta de Partner API — crea una para empezar a emitir claves.',
  buttons: {
    new_account: 'Nueva cuenta',
    edit_account: 'Editar cuenta',
    docs: 'Documentación de la API',
  },
  tabs: {
    api_keys: 'Claves de API',
    webhooks: 'Webhooks',
    deliveries: 'Entregas',
  },
  toasts: {
    load_error: 'No se pudieron cargar tus cuentas de API de Partners.',
  },
};
